import allSettled from 'hs-promise-utils/allSettled';
import { UserAttributesClient } from 'frontend-preferences-client';
const userAttributesClient = UserAttributesClient.forCaller('crm-settings-task-reminders');
function maybeParseJSON(strValue) {
  try {
    return JSON.parse(strValue);
  } catch (e) {
    return strValue;
  }
}
export function bulkGet(keys) {
  const keysToFetch = Object.fromEntries(keys.map(key => [key, '']));
  return userAttributesClient.batchFetch(keysToFetch).then(response => Object.entries(response).reduce((acc, [key, value]) => {
    if (value === '') return acc;
    acc[key] = maybeParseJSON(value);
    return acc;
  }, {}));
}
export function setAttribute(key, value) {
  return userAttributesClient.write(key, JSON.stringify(value)).then(response => ({
    [key]: maybeParseJSON(response)
  }));
}

/**
 * February 26, 2021: I am considering this okay because of the following reasons:
 * - User attributes api doesn't support bulk-set
 * - We only need to set the attributes that changed
 * - the number of api calls is the same as if we didn't have a save button
 * - this page receives very low traffic
 * - the number of attributes we set at once will most likely always be in the single digits
 * @param attributes is an object of kv pairs where the values are un-serialized
 * @return a promise resolving with the attributes that have been set
 */
export function DANGEROUS_setAttributesBulk(attributes) {
  return allSettled(Object.keys(attributes).map(key => setAttribute(key, attributes[key]))).then(results => {
    const errors = results.filter(r => r.status === 'rejected').map(r => r.reason);
    const successfulResults = results.filter(r => r.status === 'fulfilled').map(r => r.value).reduce((acc, cur) => Object.assign(acc, cur), {});
    return {
      results: successfulResults,
      error: Boolean(errors.length),
      errors
    };
  });
}